import DissolvePostFxPipeline from './shaders/dissolve/DissolvePostFxPipeline.js';
export default DissolvePostFxPipeline;
